import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import LoginPage from "../Cabinet/LoginPage/LoginPage.js";
import AdminDashboard from "../Cabinet/AdminDashboard/AdminDashboard.js";
import PatientCabinet from "../Cabinet/PatientCabinet/PatientCabinet.js"; // default экспорт
import StaffDashboard from "../Cabinet/StaffDashboard/StaffDashboard.js";
import PrivateRoute from "../PrivateRoute/PrivateRoute.js";
import RegisterPage from "../Cabinet/RegisterPage/RegisterPage.js";
// import AdminCabinet from "../Cabinet/AdminCabinet/AdminCabinet.js";

import Main from "../Main/Main.js";
// import Preloader from "../Preloader/Preloader";
import Footer from "../Footer/Footer.js";
import Header from "../Header/Header.js";
import Strip from "../Header/Strip/Strip.js";
import WeekPage from "../Main/Prevention/WeekPage/WeekPage.js";
import About from "../About/About.js";
import History from "../About/History/History.js";
import Structure from "../About/Structure/Structure.js";
import Licenses from "../About/Licenses/Licenses.js";
import Privacy from "../About/Privacy/Privacy.js";
import AntiCorruption from "../About/AntiCorruption/AntiCorruption.js";
import Controls from "../About/Controls/Controls.js";
import Vacancies from "../About/Vacancies/Vacancies.js";
import Science from "../Science/Science.js";
import Research from "../Science/Research/Research.js";
import Development from "../Science/Development/Development.js";
import Dissertation from "../Science/Dissertation/Dissertation.js";
import ClinicalTrials from "../Science/ClinicalTrials/ClinicalTrials.js";
import Publications from "../Science/Publications/Publications.js";
// import Assistance from "../Science/Assistance/Assistance.js";
import Education from "../Education/Education.js";
import Residency from "../Education/Residency/Residency.js";
import PostgraduateStudies from "../Education/PostgraduateStudies/PostgraduateStudies.js";
import Additional from "../Education/Additional/Additional.js";
import Clinic from "../Clinic/Clinic.js";
import Hospital from "../Clinic/Hospital/Hospital.js";
import DayHospital from "../Clinic/DayHospital/DayHospital.js";
import Consultative from "../Clinic/Consultative/Consultative.js";
import Laboratory from "../Clinic/Laboratory/Laboratory.js";
import Patients from "../Patients/Patients.js";
import Reception from "../Patients/Reception/Reception.js";
import ReceptionOMC from "../Patients/ReceptionOMC/ReceptionOMC.js";
import Working from "../Patients/Working/Working.js";
import Pay from "../Patients/Pay/Pay.js";
// import PreventionHealthy from "../Patients/PreventionHealthy/PreventionHealthy.js";
import Contacts from "../Contacts/Contacts.js";
import Advertisements from "../Science/Dissertation/Advertisements/Advertisements.js";
import Videobroadcast from "../Science/Dissertation/Videobroadcast/Videobroadcast.js";
import AllNews from "../About/AllNews/AllNews.js";
import WorkingConditions from "../About/WorkingConditions/WorkingConditions.js";
import AccountingPolicy from "../About/AccountingPolicy/AccountingPolicy.js";
import IndependentAssessment from "../About/IndependentAssessment/IndependentAssessment.js";
import HeatingSeason from "../About/HeatingSeason/HeatingSeason.js";
import ScientificResearch from "../Science/ScientificResearch/ScientificResearch.js";
import Certification from "../Science/Certification/Certification.js";
import Patents from "../Science/Patents/Patents.js";
import WorkingChief from "../Clinic/WorkingChief/WorkingChief.js";
import ProblemSyphilis from "../Clinic/ProblemSyphilis/ProblemSyphilis.js";
import Specialists from "../Patients/Specialists/Specialists.js";
import Provision from "../Patients/Provision/Provision.js";
import AccessibleEnvironment from "../Patients/AccessibleEnvironment/AccessibleEnvironment.js";
import Helplines from "../Patients/Helplines/Helplines.js";
import FireSafety from "../Patients/FireSafety/FireSafety.js";
import ClinicalExamination from "../Patients/ClinicalExamination/ClinicalExamination.js";
import Gosuslugi from "../Patients/Gosuslugi/Gosuslugi.js";
import TaxDeduction from "../Education/TaxDeduction/TaxDeduction.js";
import AdvancedTraining from "../Education/Additional/AdvancedTraining/AdvancedTraining.js";
import CertificationCycle from "../Education/Additional/CertificationCycle/CertificationCycle.js";
import ProfessionalRetraining from "../Education/Additional/ProfessionalRetraining/ProfessionalRetraining.js";
import TeachingStaff from "../Education/TeachingStaff/TeachingStaff.js";
import StaffDetail from "../Education/TeachingStaff/StaffDetail/StaffDetail.js";
import AdmissionsCommittee from "../Education/AdmissionsCommittee/AdmissionsCommittee.js";
import ScientificEducational from "../Education/Residency/ScientificEducational/ScientificEducational.js";
import EducationalProgram from "../Education/Residency/EducationalProgram/EducationalProgram.js";
import RegulatoryDocuments from "../Education/Residency/RegulatoryDocuments/RegulatoryDocuments.js";
import OrganizationMonitoring from "../Education/Residency/OrganizationMonitoring/OrganizationMonitoring.js";
import ClinicalBase from "../Education/Residency/ClinicalBase/ClinicalBase.js";
import ContingentStudents from "../Education/Residency/ContingentStudents/ContingentStudents.js";
import PriceList from "../Patients/PriceList/PriceList.js";
import SpecializedMedical from "../Clinic/SpecializedMedical/SpecializedMedical.js";
import SpecialistsDetail from "../Patients/Specialists/SpecialistsDetail/SpecialistsDetail.js";
import CookiePopup from "../CookiePopup/CookiePopup.js";
import ScrollToTop from "../ScrollToTop/ScrollToTop.js";
import NotFound from "../NotFound/NotFound.js";
import Sitemap from "../Sitemap/Sitemap.js";
import ParticipantsSVO from "../Patients/ParticipantsSVO/ParticipantsSVO.js";
import AntiTerror from "../About/AntiTerror/AntiTerror.js";
import QuestionAnswer from "../Patients/QuestionAnswer/QuestionAnswer.js";
import Managers from "../About/Managers/Managers.js";
import Services from "../Services/Services.js";
import PapillomaRemoval from "../Services/PapillomaRemoval/PapillomaRemoval.js";
import EmergencyNumbers from "../Patients/EmergencyNumbers/EmergencyNumbers.js";
import Reviews from "../Patients/Reviews/Reviews.js";
import NewReviews from "../Patients/Reviews/NewReviews/NewReviews.js";
// import InfoPopupBanner from "../InfoPopup/InfoPopupBanner.js";

// import InfoPopup from "../InfoPopup/InfoPopup.js";

function ScrollToHashElement() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <div className="App">
      <Header />
      <Strip />
      <ScrollToHashElement />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/patients/week" element={<WeekPage />} />

        <Route path="/about" element={<About />} />
        <Route path="/about/history" element={<History />} />
        <Route path="/about/structure" element={<Structure />} />
        <Route path="/about/managers" element={<Managers />} />
        <Route path="/about/licenses" element={<Licenses />} />
        <Route path="/about/privacy" element={<Privacy />} />
        <Route path="/about/anti-corruption" element={<AntiCorruption />} />
        <Route path="/about/anti-terror" element={<AntiTerror />} />
        <Route path="/about/controls" element={<Controls />} />
        <Route path="/about/vacancies" element={<Vacancies />} />
        <Route path="/about/news" element={<AllNews />} />
        <Route
          path="/about/working-conditions"
          element={<WorkingConditions />}
        />
        <Route path="/about/accounting-policy" element={<AccountingPolicy />} />
        <Route
          path="/about/independent-assessment"
          element={<IndependentAssessment />}
        />
        <Route path="/about/heating-season" element={<HeatingSeason />} />
        <Route path="/about/sitemap" element={<Sitemap />} />

        <Route path="/science" element={<Science />} />
        <Route path="/science/research" element={<Research />} />
        <Route path="/science/development" element={<Development />} />
        <Route path="/science/dissertation" element={<Dissertation />} />
        <Route
          path="/science/dissertation/advertisements"
          element={<Advertisements />}
        />
        <Route
          path="/science/dissertation/videobroadcast"
          element={<Videobroadcast />}
        />
        <Route path="/science/clinical-trials" element={<ClinicalTrials />} />
        <Route path="/science/publications" element={<Publications />} />
        <Route
          path="/science/scientific-research"
          element={<ScientificResearch />}
        />
        <Route path="/science/certification" element={<Certification />} />
        <Route path="/science/patents" element={<Patents />} />
        {/* <Route path="/science/assistance" element={<Assistance />} /> */}

        <Route path="/education" element={<Education />} />
        <Route path="/education/residency" element={<Residency />} />
        <Route
          path="/education/residency/scientific-educational"
          element={<ScientificEducational />}
        />
        <Route
          path="/education/residency/educational-program"
          element={<EducationalProgram />}
        />
        <Route
          path="/education/residency/regulatory-documents"
          element={<RegulatoryDocuments />}
        />
        <Route
          path="/education/residency/organization-monitoring"
          element={<OrganizationMonitoring />}
        />
        <Route
          path="/education/residency/clinical-base"
          element={<ClinicalBase />}
        />
        <Route
          path="/education/residency/contingent-students"
          element={<ContingentStudents />}
        />
        <Route
          path="/education/postgraduate-studies"
          element={<PostgraduateStudies />}
        />
        <Route path="/education/additional" element={<Additional />} />
        <Route
          path="/education/additional/advanced-training"
          element={<AdvancedTraining />}
        />
        <Route
          path="/education/additional/certification-cycle"
          element={<CertificationCycle />}
        />
        <Route
          path="/education/additional/short-improvement"
          element={<AdvancedTraining />}
        />
        <Route
          path="/education/additional/professional-retraining"
          element={<ProfessionalRetraining />}
        />
        <Route path="/education/teaching-staff" element={<TeachingStaff />} />
        <Route
          path="/education/teaching-staff/:slug"
          element={<StaffDetail />}
        />

        <Route
          path="/education/admissions-committee"
          element={<AdmissionsCommittee />}
        />
        <Route path="/education/tax-deduction" element={<TaxDeduction />} />

        <Route path="/clinic" element={<Clinic />} />
        <Route
          path="/clinic/specialized-medical"
          element={<SpecializedMedical />}
        />
        <Route path="/clinic/hospital" element={<Hospital />} />
        <Route path="/clinic/day-hospital" element={<DayHospital />} />
        <Route path="/clinic/consultative" element={<Consultative />} />
        <Route path="/clinic/laboratory" element={<Laboratory />} />
        <Route path="/clinic/laboratory" element={<Laboratory />} />
        <Route path="/clinic/laboratory" element={<Laboratory />} />
        <Route path="/clinic/working-chief" element={<WorkingChief />} />
        <Route path="/clinic/problem-syphilis" element={<ProblemSyphilis />} />

        <Route path="/patients" element={<Patients />} />
        <Route path="/patients/reception" element={<Reception />} />
        <Route path="/patients/reception-omc" element={<ReceptionOMC />} />
        <Route path="/patients/working" element={<Working />} />
        <Route path="/patients/pay" element={<Pay />} />
        <Route path="/patients/price-list" element={<PriceList />} />
        {/* <Route
          path="/patients/prevention-healthy"
          element={<PreventionHealthy />}
        /> */}
        <Route path="/patients/specialists" element={<Specialists />} />
        <Route
          path="/patients/specialists/:slug"
          element={<SpecialistsDetail />}
        />

        <Route path="/patients/provision" element={<Provision />} />
        <Route
          path="/patients/accessible-environment"
          element={<AccessibleEnvironment />}
        />
        <Route path="/patients/helplines" element={<Helplines />} />
        <Route path="/patients/fire-safety" element={<FireSafety />} />
        <Route
          path="/patients/clinical-examination"
          element={<ClinicalExamination />}
        />
        <Route path="/patients/gosuslugi" element={<Gosuslugi />} />
        <Route path="/patients/participantsSVO" element={<ParticipantsSVO />} />
        <Route path="/patients/question-answer" element={<QuestionAnswer />} />
        <Route path="/patients/reviews" element={<Reviews />} />
        <Route path="/patients/reviews/new-reviews" element={<NewReviews />} />
        <Route
          path="/patients/emergency-numbers"
          element={<EmergencyNumbers />}
        />
        <Route path="/contacts" element={<Contacts />} />
        {/* Страница 404 */}
        <Route path="*" element={<NotFound />} />

        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/cabinet"
          element={
            <PrivateRoute allowedRoles={["patient"]}>
              <PatientCabinet />
            </PrivateRoute>
          }
        />

        <Route
          path="/staff"
          element={
            <PrivateRoute allowedRoles={["operator"]}>
              <StaffDashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin"
          element={
            <PrivateRoute allowedRoles={["admin"]}>
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        <Route path="/services" element={<Services />} />
        <Route
          path="/services/udalenie-papillom"
          element={<PapillomaRemoval />}
        />
      </Routes>
      {/* <InfoPopup /> */}
      {/* <InfoPopupBanner /> */}
      <CookiePopup />
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default App;
